import { useContext } from "react";
import { RouteContextValue, RouteContext } from "@swiggy-private/core-ui";
import { CheckoutRoute } from "@swiggy-private/checkout-core";

const useForward = (): RouteContextValue<CheckoutRoute>["isForward"] => {
    return useContext(RouteContext).isForward;
};

export default useForward;
